import PropTypes from 'prop-types';
import styled from 'styled-components';
import { memo, useCallback, useState } from '@web-stories-wp/react';
import { v4 as uuidv4 } from 'uuid';
import { __ } from '@web-stories-wp/i18n';
import { getTextDepth } from '../../../../elements/text/utils/getTextDepth';
import { TextDepthFilter } from '../../../../elements/text/svgTextDisplay/textDepthFilter';

const Preview = styled.svg`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  border: 1px solid ${({ theme }) => theme.colors.divider.primary};
  border-radius: 4px;
`;

function TextDepthPreview({ textDepth, elementId }) {
  const [id] = useState(() => `depth-square-preview-${uuidv4()}`);
  const depth = getTextDepth(textDepth);
  const previewDepthFor = useCallback(
    (angle) => getTextDepth({ ...textDepth, lightDirection: angle }),
    [textDepth]
  );
  return (
    <Preview
      viewBox="-12 -12 88 88"
      role="img"
      aria-label={__('Depth preview', 'web-stories')}
    >
      {depth && (
        <defs>
          <TextDepthFilter
            cachePreview
            id={id}
            depth={depth}
            width={64}
            height={64}
            previewElementId={elementId}
            previewDepthFor={previewDepthFor}
          />
        </defs>
      )}
      <rect
        width={64}
        height={64}
        fill="#808080"
        filter={depth ? `url(#${id})` : undefined}
      />
    </Preview>
  );
}
TextDepthPreview.propTypes = {
  textDepth: PropTypes.object.isRequired,
  elementId: PropTypes.string,
};
export default memo(TextDepthPreview);
